<template>
  <!--  main div  -->
  <div class="d-flex flex-column flex">
    <div>
      <v-card height="100%">
        <v-card-title class="py-1">
          Dashboard
          <v-spacer></v-spacer>
          <!--<v-btn color="info" text depressed @click="closeAndLogin" v-if="isCleared" class="ml-4">Pay school fees-->
          <!--</v-btn>-->
        </v-card-title>
        <v-divider></v-divider>

        <v-card-text class="d-flex flex-column flex-md-row">
          <v-row justify="space-between" class="mx-2">
            <v-col cols="12" md="4" sm="12" :class="{'mx-auto': isMobile}">
              <v-alert outlined type="error" v-if="isMobile && getUser.programme != null && getUser.programme.programmeType.id !== getUser.yearOfAdmission.programmeType.id">
                There is a conflict on admission details. contact support
              </v-alert>
              <x-card :maxwidth="450" elevation="6" class="rounded-lg" outlined style="border-color: #a6821e">
                <x-card-title>
                  <v-img contain class="d-flex mx-auto rounded-circle" height="180" aspect-ratio="1" style="background-size: cover" width="180" :src="image"/>
                  <x-button outline color="secondaryLight"
                            @click.stop="showUploadPicture = !showUploadPicture"  text
                            style="position: absolute; top: 8.5em; right: 5em">
                    <v-icon color="secondaryLight" size="32">mdi-camera</v-icon>
                  </x-button>
                </x-card-title>

                <v-card-text class="mx-md-5 mx-0 mt-5" >
                  <v-row>
                    <v-col class="mb-0 pb-0"  cols="12" md="11" style="line-height: 0.1rem">
                      <div>
                        <p class="font-weight-medium">Name:</p>
                        <x-text-field :rounded="false" outlined dense :disabled="true" v-model="getUser.name" />
                      </div>
                    </v-col>


                    <v-col class="mb-0 pb-0 mt-0 pt-0" cols="12" md="11" style="line-height: 0.1rem">
                      <div >
                        <p class="font-weight-medium">ID:</p>
                        <x-text-field :rounded="false" outlined dense :disabled="true" v-model="getUser.userId" />
                      </div>
                    </v-col>


                    <v-col class="mb-0 pb-0 mt-0 pt-0"  cols="12" md="11" style="line-height: 0.1rem">
                      <div>
                        <p class="font-weight-medium">Phone Number:</p>
                        <x-text-field :rounded="false" outlined :disabled="true" dense v-model="getUser.phone" />
                      </div>
                    </v-col>


                    <v-col class="mb-0 pb-0 mt-0 pt-0" cols="12" md="11" style="line-height: 0.2rem">
                      <div>
                        <p class="font-weight-medium">Level:</p>
                        <x-text-field :rounded="false" outlined :disabled="true" dense :value="getUser.level != null ? getUser.level.title : ''" />
                      </div>
                    </v-col>
                  </v-row>
                </v-card-text>
              </x-card>
            </v-col>


            <v-col cols="12" md="8" sm="12">
              <v-alert type="error" outlined v-if="!isMobile && getUser.programme != null && getUser.programme.programmeType.id !== getUser.yearOfAdmission.programmeType.id">
                There is a conflict on admission details. contact support
              </v-alert>
              <div class="d-flex justify-space-between elevation-2 primary py-1 mx-2 px-2 rounded-lg">
                <div class="white--text">{{''}} </div>
                <div class="white--text ">
                  {{ 'Application details' + (getUser.modeOfEntry != null ? (" - " + getUser.modeOfEntry.title) : "")}}
                </div>
                <div class="white--text">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon v-bind="attrs" v-on="on" color="white" @click="reset = !reset">mdi-restore</v-icon>
                    </template>
                    <span>Restart application</span>
                  </v-tooltip>
                </div>
              </div>

              <v-row class="mx-2 px-1 elevation-2 rounded-lg">
                <v-col cols="12" md="6" class="mt-4">

                  <div style="line-height: 0.2rem">
                    <p class="font-weight-medium">Mode of study:</p>
                    <x-text-field outlined dense :rounded="false" :disabled="true" :value="getUser.programme != null ? getUser.programme.programmeType.modeOfStudy : ''" />
                  </div>

                  <div style="line-height: 0.2rem">
                    <p class="font-weight-medium">Programme type:</p>
                    <x-text-field outlined dense :rounded="false" :disabled="true" :value="getUser.programme != null ? getUser.programme.programmeType.name : ''" />
                  </div>

                  <div style="line-height: 0.2rem">
                    <p class="font-weight-medium">Department:</p>
                    <x-text-field outlined dense :rounded="false" :disabled="true" :value="getUser.programme != null ? getUser.programme.department.name : ''" />
                  </div>

                </v-col>

                <v-col cols="12" md="6" class="mt-4">

                  <div style="line-height: 0.2rem">
                    <p class="font-weight-medium">Year of Admission:</p>
                    <x-text-field outlined dense :rounded="false" :disabled="true" :value="getUser.yearOfAdmission.name" />
                  </div>

                  <div style="line-height: 0.2rem">
                    <p class="font-weight-medium">Faculty</p>
                    <x-text-field outlined dense :rounded="false" :disabled="true" :value="getUser.programme != null ? getUser.programme.department.faculty.name : ''" />
                  </div>

                  <div style="line-height: 0.2rem">
                    <p class="font-weight-medium">Programme:</p>
                    <x-text-field outlined dense :rounded="false" :disabled="true" :value="getUser.programme != null ? getUser.programme.name : ''" />
                  </div>

                </v-col>
              </v-row>

              <div class="d-flex mt-6 justify-space-between elevation-2 primary py-1 mx-2 px-2 rounded-lg">
                <div class="white--text" >{{''}} </div>
                <div class="white--text ">
                  {{ 'Application status'}}
                </div>
                <div class="white--text">{{''}} </div>
              </div>

              <v-row class="mx-2 px-1 elevation-2 rounded-lg">
                <v-col cols="12" md="6" class="mt-2">
                  <div :class="{'px-2 mt-md-0 mb-md-4 mr-md-4 ml-md-auto flex-shrink-0': true}"
                       v-if="getUser != null">
                    <v-timeline align-top dense dark>
                      <v-timeline-item color="green" small>
                        <v-row class="">
                          <v-col>
                            <strong>Application</strong>
                            <div class="text-caption" style="word-break: break-all;">{{ getUser.admission.applicationType.name }}</div>
                          </v-col>
                        </v-row>
                      </v-timeline-item>

                      <v-timeline-item :color="getUser != null && getUser.cleared ? 'green' : 'red'" small>
                        <v-row class="">
                          <v-col>
                            <strong>Status</strong>
                            <div class="text-caption" style="word-break: break-all;">{{
                                getUser.studentStatus.replaceAll("_", " ")
                              }}</div>
                          </v-col>
                        </v-row>
                      </v-timeline-item>
                    </v-timeline>
                  </div>
                </v-col>

                <v-col cols="12" md="6" class="mt-4">
                  <div class="d-flex justify-lg-space-around flex-column px-6 mt-1">
                    <div class="success pa-4 white--text rounded-lg" v-if="canSeeAdmissionOption">
                      Congratulations. You have been offered admission
                    </div>
                    <div class="error pa-4 white--text rounded-lg" v-else>
                      Admission not offered. check back later
                    </div>
                    <v-menu bottom left rounded v-if="canSeeAdmissionOption">
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn class="mt-2" color="primary" dark v-bind="attrs" v-on="on" depressed :disabled="loading">
                          Admission menu
                        </v-btn>
                      </template>

                      <v-list dense rounded>
                        <v-list-item link @click="downloadInvoice">
                          <v-list-item-title>Generate/Print invoice</v-list-item-title>
                        </v-list-item>
                        <v-list-item link v-if="canAcceptOrReject" @click="processAcceptAdmission">
                          <v-list-item-title>Accept admission</v-list-item-title>
                        </v-list-item>

                        <v-list-item link v-if="canAcceptOrReject">
                          <v-list-item-title class="error--text" @click="showConfirmReject = true">Reject offer
                          </v-list-item-title>
                        </v-list-item>

                        <v-list-item link v-if="hasAcceptedAdmission" @click="downloadLetter" :disabled="loading">
                          <v-list-item-title>Download admission letter</v-list-item-title>
                        </v-list-item>
                      </v-list>
                    </v-menu>
                  </div>
                </v-col>
              </v-row>

            </v-col>

          </v-row>
        </v-card-text>
      </v-card>
    </div>

    <loading-dialog :show="loading"></loading-dialog>
    <message-box :show="messageShow" :message="message" :type="messageType"
      v-on:close-message="messageShow = !messageShow"></message-box>
    <!--  confirmation box for rejecting admission  -->
    <confirmation-box message="Are you sure you want to reject admission? This action can not be reversed"
      :show="showConfirmReject" v-on:positive="rejectAdmission" v-on:negative="showConfirmReject = false">
    </confirmation-box>
    <reset-application v-if="showReset" :show="reset" @close-dialog="reset = false"></reset-application>
    <profile-picture-upload :show="showUploadPicture" v-on:close="showUploadPicture = !showUploadPicture"
      :user="getUser" v-on:uploaded="profilePictureUploaded"></profile-picture-upload>
  </div>

</template>


<script>
import Defaults from "@/shared/Defaults";
import { mapGetters } from "vuex";
import LoginUtil from "@/login/LoginUtil";
import StudentStatus from "@/shared/StudentStatus";
import MessageBox from '@ui/components/MessageBox';
import LoadingDialog from '@ui/components/LoadingDialog';
import ErrorResolver from '@/shared/ErrorResolver';
import Api from '@/main/api';
import ConfirmationBox from "@/components/ConfirmationBox";
import { PaymentGateway } from "@/shared/PaymentGateway";
import GateWays from "@/shared/GateWays";
import Links from "@/shared/constants/Links";
import ProfilePictureUpload from '../../../components/ProfilePictureUpload.vue';
import ResetApplication from "@/application/pages/lafia/components/ResetApplication";
import XTextField from "@ui/widgets/XTextField.vue";
import XCard from "@ui/components/XCard.vue";
import XCardTitle from "@ui/components/XCardTitle.vue";
import XButton from "@ui/widgets/XButton.vue";

export default {
  name: "Dashboard",
  components: {
    XButton,
    XCardTitle,
    XCard,
    XTextField,
    ResetApplication,
    ConfirmationBox,
    // eslint-disable-next-line vue/no-unused-components
    MessageBox,
    LoadingDialog,
    ProfilePictureUpload
  },

  data: () => ({
    items: [
      {
        color: 'red lighten-2',
        icon: 'mdi-star',
      },
      {
        color: 'purple darken-1',
        icon: 'mdi-book-variant',
      },
    ],

    image: '',
    messageType: '',
    message: '',
    messageShow: false,
    loading: false,
    reset: false,
    showConfirmReject: false,
    paymentGateway: null,
    payment: null,
    paymentConfig: null,
    showUploadPicture: false,
    editPhone: false,
    obj: {
      phone: ''
    }
  }),


  methods: {
    rejectAdmission: function () {
      this.loading = true;

      Api.applicants.rejectAdmission(this.getUser.id).then(res => {
        this.messageShow = true;
        this.messageType = "success";
        this.message = "Admission rejected"
        this.$store.commit('setCurrentUser', res.data)
      }).catch((err) => {
        ErrorResolver.checkErrors(this, err);
      }).finally(() => {
        this.loading = this.showConfirmReject = false;
      })
    },

    processAcceptAdmission() {
      if (this.getUser != null) {
        if (this.getUser.admission.applicationType.admissionFee > 0.1) {
          this.initializePayment()
        } else {
          this.acceptAdmission();
        }
      }
    },

    profilePictureUploaded() {
      window.location.reload()
    },

    acceptAdmission() {
      this.loading = true
      Api.applicants.acceptAdmission(this.getUser.id)
        .then(res => {
          this.message = 'Admission accepted'
          this.messageType = 'success'
          this.messageShow = true
          this.$store.commit('setCurrentUser', res.data)
        }).catch(err => ErrorResolver.checkErrors(this, err))
        .finally(() => this.loading = false)
    },

    updatePhone() {
      this.loading = true
      Api.applicants.updatePhone(this.getUser.id, this.obj)
          .then(res => {
            this.message = 'Phone number updated'
            this.messageType = 'success'
            this.messageShow = true
            this.$store.commit('setCurrentUser', res.data)
          }).catch(err => ErrorResolver.checkErrors(this, err))
          .finally(() => {
            this.loading = false
            this.editPhone = false
          })
    },

    downloadInvoice() {
      this.loading = true;
      Api.applicants.acceptanceInvoice(this.getUser.id)
        .then(res => {
          let fileURL = window.URL.createObjectURL(new Blob([res.data], { type: 'application/pdf' }));
          let fileLink = document.createElement('a');

          fileLink.href = fileURL;
          fileLink.setAttribute('download', 'invoice.pdf');
          document.body.appendChild(fileLink);

            fileLink.click();
            fileLink.remove();
          }).catch(err => ErrorResolver.checkErrors(this, err)).finally(() => this.loading = false)
    },

    downloadLetter() {
      this.loading = true;
      Api.admission.getLetter(this.getUser.userId)
        .then(res => {
          let fileURL = window.URL.createObjectURL(new Blob([res.data], { type: 'application/pdf' }));
          let fileLink = document.createElement('a');

          fileLink.href = fileURL;
          fileLink.setAttribute('download', 'admission.pdf');
          document.body.appendChild(fileLink);

            fileLink.click();
            fileLink.remove();
          }).catch(err => {
        ErrorResolver.checkErrors(this, err);
      }).finally(() => this.loading = false)
    },

    initializePayment() {
      // initialize and get invoice
      this.loading = true
      Api.applicants.initializeAcceptanceFeeTransaction(this.getUser.id)
        .then(res => {
          this.payment = res.data
          // show alert and make payment
          this.message = 'Initialized'
          this.messageType = 'success'
          this.messageShow = true
          this.makePayment()
        }).catch(err => ErrorResolver.checkErrors(this, err))
        .finally(() => this.loading = false)
    },

    makePayment() {
      if (this.payment != null) {
        // _^-^_ always check for inline first
        if (this.paymentConfig.inline) {
          // do this
          this.paymentGateway.makePayment({
            email: this.getUser.email,
            amount: this.getUser.admission.applicationType.admissionFee,
            currency: 'NGN',
            invoice: this.payment.transactionId,
            paymentId: this.payment.id
          }, () => {
            window.location.reload()
          }, (invoice) => {
            // process
            this.loading = true
            Api.payment.processInline(invoice)
                .then(() => {
                  window.location.href = "/application"
                }).catch(err => {
              ErrorResolver.checkErrors(this, err)
              this.loading = false
            })
          })
        } else {
          // payment should not be done inline
          // open window for payment
          this.loading = true
          window.location.href = this.payment.paymentLink
        }
      }
    },

    logout() {
      LoginUtil.resetAccessToken();
      LoginUtil.resetRefreshToken();
      // this.$store.commit("setCurrentUser", {user: null, superOption: false});
      this.$store.commit("setInformation", null);
      window.location.reload();
    },

    closeAndLogin() {
      window.location.href = '/student'
    },

  },

  watch: {
    getUser: function (val) {
      if (val != null) {
        this.image = Defaults.api + '/profile-picture/fetch?user=' + this.getUser.userId;
        this.obj.phone = val.phone
      }
    }
  },

  computed: {
    isMobile: function () {
      return this.$vuetify.breakpoint.smAndDown
    },

    canSeeAdmissionOption() {
      return this.getUser != null && StudentStatus[this.getUser.studentStatus].value === StudentStatus.ADMISSION_OFFERED.value
        || StudentStatus[this.getUser.studentStatus].value === StudentStatus.ADMISSION_ACCEPTED.value || this.getUser.studentStatus === StudentStatus.CLEARED.text
        || this.getUser.studentStatus === StudentStatus.STUDENT.text;
    },

    canChangeImage(){
      return this.getUser != null && StudentStatus[this.getUser.studentStatus].value < StudentStatus.STUDENT.value
    },

    canAcceptOrReject() {
      return this.getUser != null && (this.getUser.studentStatus === StudentStatus.ADMISSION_OFFERED.text || this.getUser.studentStatus === StudentStatus.PROGRAMME_CHANGE.text);
    },

    hasAcceptedAdmission: function () {
      return this.getUser != null &&
        (this.getUser.studentStatus === StudentStatus.ADMISSION_ACCEPTED.text || this.getUser.studentStatus === StudentStatus.CLEARED.text
          || this.getUser.studentStatus === StudentStatus.STUDENT.text || this.getUser.studentStatus === StudentStatus.PROGRAMME_CHANGE.text);
    },

    isCleared: function () {
      return this.getUser != null && this.getUser.cleared;
    },

    showReset: function(){
      return this.getUser != null && StudentStatus[this.getUser.studentStatus].value <= StudentStatus.SCREENING_NOT_SUCCESSFUL.value
    },

    canUploadPicture: function () {
      return this.getUser != null && this.getUser.profilePicture == null;
    },

    ...mapGetters(['getUser'])
  },

  mounted() {
    // initialize gateway
    this.$nextTick(() => {
      this.paymentGateway = new PaymentGateway(GateWays.PAYSTACK, this, Links.payments.processInlinePayment)
      Api.paymentPlatforms.getActive()
        .then(res => {
          if (this.paymentGateway != null) {
            // set config
            this.paymentConfig = res.data
            // if inline, initialize
            if (res.data.inline)
              this.paymentGateway.initializeGateway(res.data)
          } else {
            this.message = 'No payment settings found'
            this.messageType = 'error'
            this.messageShow = true
          }
        }).catch(err => ErrorResolver.checkErrors(this, err))
    })
  },

  created() {
    if (!LoginUtil.getAccessToken() && !LoginUtil.getRefreshToken()) { // not logged in
      this.$router.push('/')
      return;
    }

    if (this.getUser != null) {
      this.image = Defaults.api + '/profile-picture/fetch?user=' + this.getUser.userId;
      this.obj.phone = this.getUser.phone
    }
  }
}
</script>



<style lang="css" scoped>

/** enter and leave animation for the toggle and input of phone number */
.update-phone-enter-active {
  transition: all 0.3s ease-out;
}

.update-phone-leave-active {
  transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
}

.update-phone-enter-from,
.update-phone-leave-to {
  transform: translateX(20px);
  opacity: 0;
}


@media only screen and (width: 768px) and (height: 1024px) {
  img {
    background-color: red;
  }
}

.w-pc30{
  width: 30%;
}

.w150{
  width: 150px;
}

.w200{
  width: 200px;
}
</style>
